import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Radio, Checkbox, Select, App, Modal } from 'antd';
import styles from './index.module.scss';

import PlaceOrderChild from './PlaceOrderChild';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');






const EmergencyServicePlaceOrder: React.FC = () => {

 

  return (
    <Elements stripe={stripePromise}>
      <PlaceOrderChild />
    </Elements>
  );
};

export default EmergencyServicePlaceOrder; 